import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import api from "@/services/api";

import Loader from "@/components/Loader";

const PRODUCT_STRINGS = {
  PITCH_DECK: "product.levee.pitch_deck.title",
  BP: "product.levee.bp.title",
  DIAGNOSTIC: "product.levee.diagnostic.title",
  RELATION: "product.levee.realtion.title",
};

const PRODUCT_PRICES = {
  PITCH_DECK: "product.levee.pitch_deck.price",
  BP: "product.levee.bp.price",
  DIAGNOSTIC: "product.levee.diagnostic.price",
  RELATION: "product.levee.realtion.price",
};

const View = () => {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const { ok, data } = await api.get(`/company/${id}`);
      if (!ok) throw new Error("Error fetching company data");
      if (!data.levee_has_paid) return navigate("../new");
      setCompany(data);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  if (!company) return <Loader />;

  return (
    <div className="w-full space-y-8 max-w-5xl mx-auto">
      <h1 className="text-xl font-semibold my-8">
        Accompagnement Levée de fonds pour {company.company_name}
        <br />
        <br />
        <span className="text-green-700 border border-green-700 px-4 py-2 rounded mt-2 bg-green-100 font-medium">Paiement Validée</span>
      </h1>
      <div>
        <h1 className="text-lg text-primary font-semibold mb-2">Informations</h1>
        <div className="space-y-4">
          <div className="border border-secondary p-3 rounded-lg grid grid-cols-2 gap-2 text-lg shadow">
            <div>
              <label className="text-sm text-primary">Nom de l'entreprise</label>
              <p className="font-semibold">{company.company_name}</p>
            </div>
            <div>
              <label className="text-sm text-primary">SIREN</label>
              <p className="font-semibold">{company.company_siren}</p>
            </div>
            <div>
              <label className="text-sm text-primary">Taille d'entreprise</label>
              <p className="font-semibold">{company.company_category}</p>
            </div>
            <div>
              <label className="text-sm text-primary">Secteur d'activité</label>
              <p className="font-semibold">{company.company_activity}</p>
            </div>
            <div>
              <label className="text-sm text-primary">Date de création</label>
              <p className="font-semibold">{company.company_started_at ? new Date(company.company_started_at).toLocaleDateString("fr-FR") : "-"}</p>
            </div>
          </div>

          <h1 className="text-lg text-primary font-semibold mb-2">Produit</h1>
          <div className="border border-secondary p-3 rounded-lg grid grid-cols-2 gap-2 text-lg shadow">
            <div>
              <label className="text-sm text-primary">Plan</label>
              <p className="font-semibold">
                {t(PRODUCT_STRINGS[company.levee_plan])} ({t(PRODUCT_PRICES[company.levee_plan])})
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center w-full">
        <Link to={`/my-service`} className="primary-button px-10">
          Retour a la liste
        </Link>
      </div>
    </div>
  );
};

export default View;
